import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import CheckIcon from 'Assets/icons/check.svg';

const SAVED_FLASH_MS = 1400;

const optionClassName = (active) =>
    classNames(
        'tw-text-xs tw-font-medium',
        active ? 'tw-text-charcoal tw-font-semibold tw-cursor-default' : 'tw-text-blue tw-underline hover:tw-text-dark-blue',
    );

/**
 * Row view (expand/collapse every group), Pill text (calendar only) and the brief confirmation
 * shown after the server accepts a settings save.
 */
const RoadmapRowBar = ({ showPillText, pill, savedAt, onExpandAll, onCollapseAll, onPillChange }) => {
    const [showSaved, setShowSaved] = useState(false);

    useEffect(() => {
        if (!savedAt) {
            return undefined;
        }

        setShowSaved(true);
        const timer = setTimeout(() => setShowSaved(false), SAVED_FLASH_MS);

        return () => clearTimeout(timer);
    }, [savedAt]);

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2">
            <div className="tw-flex tw-items-center tw-gap-x-2">
                <span className="tw-text-xs tw-font-medium tw-text-charcoal-50">{$t('Row view')}</span>
                <button type="button" className={optionClassName(false)} onClick={onExpandAll}>
                    {$t('Expand all')}
                </button>
                <button type="button" className={optionClassName(false)} onClick={onCollapseAll}>
                    {$t('Collapse all')}
                </button>
            </div>

            {showPillText && (
                <div className="tw-flex tw-items-center tw-gap-x-2">
                    <span className="tw-text-xs tw-font-medium tw-text-charcoal-50">{$t('Pill text')}</span>
                    <button
                        type="button"
                        className={optionClassName(pill === 'expanded')}
                        aria-pressed={pill === 'expanded'}
                        onClick={() => onPillChange('expanded')}
                    >
                        {$t('Expanded')}
                    </button>
                    <button
                        type="button"
                        className={optionClassName(pill === 'compact')}
                        aria-pressed={pill === 'compact'}
                        onClick={() => onPillChange('compact')}
                    >
                        {$t('Compact')}
                    </button>
                </div>
            )}

            <span
                role="status"
                className={classNames(
                    'tw-ms-auto tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-medium tw-text-dark-green tw-transition-opacity tw-duration-300',
                    showSaved ? 'tw-opacity-100' : 'tw-opacity-0',
                )}
            >
                <CheckIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                {$t('View settings saved')}
            </span>
        </div>
    );
};

export default RoadmapRowBar;
